export default "__VITE_ASSET__VUwI50xw__"